import { Content } from '../../types';

export const thailandTaxRefundContent: Content = {
  title: 'החזרי מס לתיירים בתאילנד',
  imageUrl: '/images/thailand/tax-refund/tax-refund-wide.jpeg',
  introduction: `בהתאם למדיניות הממשלה בתאילנד, תיירים זכאים להחזר מע"מ (VAT Refund) על רכישות שביצעו במהלך שהותם במדינה, בתנאי שיעמדו בקריטריונים שנקבעו על ידי רשות המסים התאילנדית. מדובר בהטבה משמעותית שיכולה לחסוך סכומים נכבדים, במיוחד בקניות גדולות.`,
  sections: [
    {
      title: 'התנאים לקבלת החזר מס',
      type: 'sub-headers',
      description: 'על מנת להיות זכאי להחזר המס, עליך לעמוד בתנאים הבאים:',
      content: [
        {
          subtitle: 'אזרחות לא תאילנדית',
          text: 'כלומר, אינך מחזיק בדרכון זר ואינך מתגורר דרך קבע בתאילנד.',
        },
        {
          subtitle: 'רכישה מחנויות המשתתפות בתוכנית',
          text: 'יש לוודא שהחנות בה מבוצעת הרכישה מציעה החזרי מע"מ ומספקת טופס החזר (PP10). לרוב, מדובר על חנויות בקניונים.',
        },
        {
          subtitle: 'סכום קנייה מינימלי',
          text: 'יש לקנות בסכום מינימאלי של 2,000 באט בחנות אחת ביום אחד ובסך הכול לפחות 5,000 באט מכלל הקניות במהלך הביקור.',
        },
        {
          subtitle: 'הגשת הטפסים בשדה התעופה',
          text: 'יש להציג את המוצרים, קבלות מקוריות, וטופס PP10 לפני היציאה מתאילנד.',
        },
      ],
    },
    {
      title: 'שלבים לקבלת החזר המס',
      type: 'sub-headers',
      description: 'תהליך קבלת החזר המס כולל מספר שלבים שחשוב להקפיד עליהם:',
      content: [
        {
          subtitle: 'בעת הרכישה',
          text: 'יש לבקש מהמוכר טופס החזר מס (PP10) ולוודא שהוא ממולא כראוי עם כלל הפרטים האישיים והחשבוניות הרלוונטיות.',
        },
        {
          subtitle: 'באזור הייעודי להחזרי המס בשדה התעופה',
          text: 'קודם לביצוע הצ\'ק-אין, יש לגשת לדלפק "VAT Refund for Tourists" ולהציג את המוצרים, הקבלות וטופס PP10 לחתימת הפקידים.',
        },
        {
          subtitle: 'לאחר ביקורת הדרכונים',
          text: 'במתחם הדיוטי פרי בשדה התעופה, לאחר מעבר ביקורת הדרכונים, ניתן לגשת לדוכן החזר המס ולקבל את הכסף במזומן (או באופציות אחרות כגון העברה בנקאית).',
        },
        {
          subtitle: 'עבור טיסות היוצאות מהטרמינל החדש SAT – 1',
          text: 'נדרש להגיע לדוכן החזרי המס קודם לירידה לרכבת המובילה לטרמינל (D1 – D4). שימו לב לכך, נכון לשעה זו, אין דוכן החזרי מס בטרמינל החדש.',
        },
      ],
    },
    {
      title: 'דגשים חשובים',
      type: 'sub-headers',
      description: 'מספר דגשים חשובים שיש לשים לב אליהם בתהליך החזר המס:',
      content: [
        {
          subtitle: 'מוצרים יקרי ערך',
          text: 'מוצרים יקרי ערך כגון תכשיטים, שעונים ומכשירים אלקטרוניים חייבים להיות מוצגים לבדיקת פקידי המכס, בהתאם לבקשתו.',
        },
        {
          subtitle: 'מוצרים מתכלים',
          text: 'החזר המס אינו חל על מוצרים מתכלים כגון מזון, שתייה ודלק.',
        },
        {
          subtitle: 'שיעור ההחזר',
          text: 'סכום ההחזר הינו 7% מהמחיר ששולם, אך בניכוי עמלת עיבוד (מה שמשאיר בפועל החזר של כ- 4 עד 6%).',
        },
        {
          subtitle: 'החזרים גדולים',
          text: 'במקרים בהם סכום ההחזר עולה על 30,000 באט, ייתכן שההחזר יבוצע בהעברה בנקאית ולא במזומן.',
        },
        {
          subtitle: 'הצגת דרכון',
          text: 'בעת מילוי טופס החזר המס ע"י החנות, יש להציג דרכון או צילום דרכון.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content: `תכנית החזר המע"מ לתיירים בתאילנד הינה דרך נהדרת לחסוך כסף במסגרת הקניות שתבצעו בביקורכם בממלכה. עם זאת, חשוב להקפיד על מילוי כלל הדרישות, לשמור על הקבלות ולהגיש את הטפסים כנדרש. כך ניתן יהא להבטיח קבלת החזר בקלות וללא עיכובים מיותרים.`,
      type: 'text',
      isBold: true,
    },
    {
      title: 'טבלת סכומי ההחזרים',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/tax-refund/tax-refund-article-1.jpeg',
    },
  ],
};
